import React from 'react';
import DefaultModal from '../defaultModal/DefaultModal';
import { ReactComponent as GRLogo } from '../../../../../resources/images/svg/GRLogo.svg';
import useTranslation from '../../../../hooks/translation/useTranslation';
import SocialAuthButtons from '../registerModal/components/SocialAuthButtons';
import AuthorizeForm from '../../../forms/authorize/AuthorizeForm';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import './AuthorizeModal.scss';

function AuthorizeModal({
  form, loading, errors, handleSubmit, handleNotRegistered,
}) {
  const { trans, configInfo } = useTranslation();
  const { width } = useWindowDimensions();
  const { showAuthModal, setShowAuthModal } = useModal();

  const isGeorgia = configInfo?.countryCode === 'GE';

  return (
    <DefaultModal className="auth-modal" centered show={showAuthModal && width >= 1024} setShow={setShowAuthModal} width="1016px">
      <div className="flex flex-col gap-[50px]">
        <div className="flex justify-between items-center">
          <h1 className="m-0 text-4xl">{trans('authorization')}</h1>
          {isGeorgia ? <GRLogo />
            : (
              <img
                src="/ticketLogos/mobileLogoArm.png"
                alt="Armenia Railway Logo"
                width={90}
                height={42}
              />
            )}
        </div>
        <div className="flex flex-col gap-4 items-end">
          <h3 className="m-0 text-base">
            {trans('still_not_authorized')}
          </h3>
          <button type="button" className="bg-transparent border-0 cursor-pointer" onClick={handleNotRegistered}>
            <h2 className="m-0 text-xl text-primary">{trans('registration')}</h2>
          </button>
        </div>
        <div className="flex flex-col gap-6">
          {isGeorgia && (
          <>
            <SocialAuthButtons />
            <div className="flex gap-6 items-center">
              <div className="h-[1px] grow bg-gray-semi-light-gr" />
              <p className="m-0 text-sm text text-gray-gr">{trans('or')}</p>
              <div className="h-[1px] grow bg-gray-semi-light-gr" />
            </div>
          </>
          )}
          <AuthorizeForm
            errors={errors}
            loading={loading}
            form={form}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
    </DefaultModal>
  );
}

export default AuthorizeModal;
